import { Pagination } from 'pleinchamp-api-client';

export interface ExtendedPagination extends Pagination {
  hasNext: boolean;
  current: number;
}

export const defaultExtendedPagination = {
  count: 0,
  current: 0,
  hasNext: false,
  limit: 0,
  offset: 0,
};

export const extendPagination = (pagination: Pagination): ExtendedPagination => {
  const current = Math.min(pagination.offset + pagination.limit, pagination.count);
  const hasNext = current < pagination.count;

  return {
    ...pagination,
    current,
    hasNext,
  };
};
